import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { List, Toast, Avatar } from "antd-mobile";
import {
  FileOutline,
  StopOutline,
  MinusCircleOutline,
  HistogramOutline
} from 'antd-mobile-icons';
import { logout } from '../../redux/slice/loginSlice';
import BottomNavLayout from "../../components/BottomNavLayout";
import api from "../../api";
import { isWxOrAli } from "../../utils/env";

const User = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginState = useSelector((state) => state.login)

  const listClickNavigate = (path) => {
    navigate(path)
  }

  const logoutHandle = () => {
    api.logout().then((res) => {
      dispatch(logout())

      // 判断当前是微信 or 支付宝
      const aliOrWx = isWxOrAli();

      if (aliOrWx === 'alipay') {
        navigate('/login/alipay')
      } else {
        navigate('/login/wechat')
      }
    });
  }

  return (
    <BottomNavLayout>
      <List>
        <List.Item
          prefix={<Avatar src={loginState?.avatar} />}
          description={loginState?.mobile}
        >
          {loginState?.name ? loginState?.name : loginState?.nickname}
        </List.Item>
      </List>
      <br />
      <List header='个人中心'>
        {/*
        <List.Item prefix={<UserOutline />} onClick={listClickHandle}>
          个人信息
        </List.Item>
        */}
        <List.Item prefix={<FileOutline />} onClick={() => listClickNavigate('/wallet/1')}>
          会员卡信息
        </List.Item>
        <List.Item prefix={<FileOutline />} onClick={() => listClickNavigate('/card/list')}>
          IC卡列表
        </List.Item>
        <List.Item prefix={<StopOutline />} onClick={() => listClickNavigate('/illegal')}>
          违规记录
        </List.Item>

        {
          loginState?.houseMember ?
            <List.Item prefix={<HistogramOutline />} onClick={() => listClickNavigate('/report')}>
              订单数据统计
            </List.Item>
            :
            null
        }

      </List>
      <br />
      <List header='账号'>
        <List.Item prefix={<MinusCircleOutline />} onClick={logoutHandle}>
          退出登陆
        </List.Item>
      </List>
    </BottomNavLayout>
  )
}

export default User;